import React from 'react';
import type { FC } from 'react';

import { Box, CircularProgress, SxProps, Theme, Typography } from '@mui/material';

type Props = {
  message?: React.ReactNode | string;
  sx?: SxProps<Theme>;
};

const LoadingScreen: FC<Props> = ({ message, sx }) => {
  return (
    <Box
      sx={[
        {
          alignItems: 'center',
          backgroundColor: (theme) => theme.palette.background.default,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          minHeight: '100%',
          gap: 1,
          padding: (theme) => theme.spacing(3),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <CircularProgress size={32} sx={{ color: 'text.secondary' }} />
      {message && (
        <Typography variant="caption" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingScreen;
